import styles from './GridContainer.module.css';

interface GridContainerProps {
    children: React.ReactNode;
    minWidthColumns?: string;
    oneColumnOnMobile?: boolean;
    gap?: string;
    maxWidthContainer?: string;
    containerAlignment?: 'center' | 'flex-start' | 'flex-end';
}

export const GridContainer = ({ 
    children, 
    minWidthColumns = '200px', 
    gap = '16px', 
    oneColumnOnMobile = true, 
    maxWidthContainer = '100%', 
    containerAlignment = 'center' 
}: GridContainerProps) => {
  return (
    <div className={styles.grid__container} style={{justifyContent: containerAlignment}}>
        <div 
            className={`${styles.grid} ${oneColumnOnMobile ? styles.one_column_on_mobile : ''}`}
            style={{ gridTemplateColumns: `repeat(auto-fill, minmax(${minWidthColumns}, 1fr))`, gap: gap, maxWidth: maxWidthContainer }}
        >
            {children}
        </div>
    </div>
  );
};
